import React from 'react';
import AceEditor from 'react-ace';
import 'brace/mode/sql';
import 'brace/mode/json';
import 'brace/mode/javascript';
import 'brace/theme/textmate';
import 'brace/ext/language_tools';
import classes from './editor.module.scss';

interface ICodeEditorProps {
  code: string;
  onChange?: (code: string) => void;
  language?: string;
  readOnly?: boolean;
  disableScrolling?: boolean;
  tabSize?: number;
}
const CodeEditor = ({
  code,
  onChange,
  language,
  readOnly,
  disableScrolling,
  tabSize,
}: ICodeEditorProps) => (
  <div className={classes.code_editor_wrapper}>
    <AceEditor
      value={code}
      readOnly={readOnly}
      mode={language || 'javascript'}
      theme="textmate"
      onChange={onChange}
      name="UNIQUE_ID_OF_DIV"
      editorProps={{ $blockScrolling: true }}
      showPrintMargin={false}
      width="100%"
      wrapEnabled
      highlightActiveLine
      setOptions={{
        enableLiveAutocompletion: !readOnly,
        ...(tabSize && { tabSize }),
      }}
      maxLines={disableScrolling ? Infinity : undefined}
    />
  </div>
);
export default CodeEditor;
